<template>
  <div v-if="pageIsLoading" class="authorization-layout">
    <slot></slot>
  </div>
  <div class="loading-authorization-layout" v-else>
    <b-spinner label="Spinning"></b-spinner>
  </div>
</template>

<script>
  export default {
    name: 'AuthorizationLayout',
    computed: {
      pageIsLoading() {
        return !!this.$route.name
      }
    }
  }
</script>

<style lang="scss">
  .authorization-layout {
    height: 100vh;
    width: 100%;
  }

  .loading-authorization-layout {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    z-index: 1999;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/AuthorizationLayout.vue